/**
 * Generates a random positive integer.
 *
 * @returns {Number}
 */
export function generateRandomNumber()
{
	return Math.round(Math.random() * 10000000);
};
